import { Route, Routes } from "react-router-dom";

import UserProfile from "./panel/userProfile/UserProfile";
import PagesOfUnit from "./pages/PagesOfUnit";
import UnitsOfBook from "./pages/UnitsOfBook";
import NotFound from "./panel/NotFound";
import Login from "./panel/login/Login";
import HomePage from "./pages/HomePage";
import ShowPage from "./pages/ShowPage/ShowPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="profile" element={<UserProfile />} />
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="/book/:bookId" element={<UnitsOfBook />} />
      <Route exact path="/units/:unitId" element={<PagesOfUnit />} />
      <Route exact path="/show/:unitId" element={<ShowPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
